import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ActiveMailTemplate extends BaseAPIModel {
    // Allow us to call getAll directly
    static list(item) {
        return this.fromJSON(item);
    }

    static listUrl({ organizationId, partnerId, key }) {
        if (!organizationId || !key) {
            throw new ArgumentError(`[Model][ActiveMailTemplate] organizationId and keyId are mandatory`);
        }

        if (partnerId) {
            return `/ticket/organizations/${organizationId}/partners/${partnerId}/mailing/rules/${key}/resolve`;
        }

        return `/ticket/organizations/${organizationId}/mailing/rules/${key}/resolve`;
    }
}
